import React from "react";
import HeaderCities from "../components/HeaderCities";
import ShedRemovalFAQs from "../components/ShedRemovalFAQs";
// import ServicesArea from "../components/ServicesArea";
import UpperFooter from "../components/UpperFooter";
import "../assets/css/services.css";

function Shed() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Need shed removal? We provide professional demolition and removal at a great price. Free estimate today!"
        />
        <base href="/" />

        <link
          rel="preload"
          as="image"
          href="/assets/img/shed-removal.webp"
          type="image/webp"
        />
        <link
          rel="canonical"
          href="https://junkdroid.com/services/shed-removal/"
        />
        <title>
          Shed Removal | Fast, Affordable & Eco-Friendly | Junk Droid
        </title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Hero Section Start HERE =========================  */}
        <div className="container-fluid madeesay-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Services</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Shed Removal
                    </li>
                  </ol>
                </nav>
                <h1>
                  Shed Removal <span>Made Easy</span>
                </h1>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <div className="inner-img">
                  <img src="/assets/img/shed-removal.webp" alt="shed removal" />
                </div>
                <p>
                  Need shed removal? We handle heavy lifting, debris disposal,
                  and cleanup for wooden, metal, or broken sheds. Stress-free,
                  professional shed removal services for homeowners and
                  businesses. Free estimate today!
                </p>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                    <a href="tel:4085397261">
                      <button type="button" className="btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                          />
                        </svg>{" "}
                        &nbsp; CALL NOW
                      </button>
                    </a>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                    <h4>Rated 5.0 on Google</h4>
                    <div className="rating-sec">
                      <span>5.0</span> &nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill ms-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 desk-img">
                <img src="/assets/img/shed-removal.webp" alt="shed removal" />
              </div>
            </div>
          </div>
        </div>
        {/* ================== Hero Section End HERE =========================  */}
        {/* ================== First  Section Start HERE =========================  */}
        <hr />
        <div className="container-fluid overview-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="major-heading">
                  Affordable Shed <span>Removal Service</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Our expert team specializes in full-service shed removal,
                  including shed demolition, cleanup services, and disposal.
                  Whether you’re clearing space for a next project or simply
                  getting rid of an unwanted shed, we handle everything from
                  dismantling to yard waste removal.
                </p>
                <p className="service-description">
                  We offer convenient on-site removal and cleanup, making the
                  removal process effortless. Committed to eco-friendly
                  practices, we partner with local charities and recycling
                  centers to donate or responsibly recycle usable materials like
                  scrap metal and items in good condition. Our goal is to reduce
                  environmental impact while providing you with a fair price and
                  great service.
                </p>

                {/* ============ */}
                <h3>
                  Why Choose Us for Your <span>Shed Removal Needs?</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Experienced Team:</span>&nbsp;Our professionals are
                    trained to handle shed demolition services of all sizes,
                    from small backyard sheds to large storage structures. We
                    take care of everything, including light demolition,
                    appliance removal, and construction debris removal.
                  </li>
                  <li>
                    <span>Transparent Pricing:</span>&nbsp;No hidden fees or
                    unexpected disposal fees! We provide free estimates and
                    upfront pricing, so you know exactly what to expect.
                  </li>
                  <li>
                    <span>Eco-Friendly Practices:</span>&nbsp;We prioritize
                    reducing waste by recycling materials like scrap metal and
                    donating usable items to local charities.
                  </li>
                  <li>
                    <span>Flexible Scheduling:</span>&nbsp;Need same-day service
                    or weekend appointments? We offer flexible scheduling to fit
                    your needs.
                  </li>
                  <li>
                    <span>Great Service:</span>&nbsp;From start to finish, we
                    treat your property with care and ensure the area is left
                    clean and ready for use.
                  </li>
                </p>
                {/* ============ */}
                <h3>
                  How It <span>Works</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Get a Free Quote:</span>&nbsp;Contact us for a free
                    estimate or instant quote today.
                  </li>
                  <li>
                    <span>Schedule Your Removal:</span>&nbsp;Choose a time that
                    works for you, including same-day service options.
                  </li>
                  <li>
                    <span>We Handle the Heavy Lifting:</span>&nbsp;Our team
                    arrives with the necessary safety equipment to dismantle and
                    remove your shed.
                  </li>
                  <li>
                    <span>Payment Options:</span>&nbsp;We accept cash, debit,
                    credit, checks, or Zelle.
                  </li>
                  <li>
                    <span>Eco-Friendly Disposal:</span>&nbsp;We ensure materials
                    are recycled, donated, or disposed of responsibly.
                  </li>
                </p>
                {/* ===================================================================================0 */}
                {/* <h3>
                  Service <span>Area</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  We proudly serve homeowners and businesses in the following
                  service areas:
                </p> */}
                {/* ===================================================================================0 */}
                {/* <ServicesArea /> */}
                <div className="row">
                  <div className="com-md-12 overview-sec service-desc">
                    <h3 className="pt-0">
                      Book Now for a <span>Stress-Free Experience</span>
                    </h3>
                    <div className="sliderline-svg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={64}
                        height={4}
                        viewBox="0 0 64 4"
                        fill="none"
                      >
                        <path
                          d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                          fill="#60BDFF"
                        />
                      </svg>
                    </div>
                    <p>
                      Don’t let an unwanted shed take up valuable space on your
                      property. Whether you need shed tear down, cleanup
                      services, or junk removal, our team is here to help. Call
                      today for a free quote and let us handle the hard work so
                      you can focus on your next project.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ================== First  Section End HERE =========================  */}
        {/* ================= What We Take Section Start Here ================= */}
        <div className="container-fluid more-detail-sec we-take-sec">
          <div className="container junk-container">
            <div className="row">
              <div className="col-md-12">
                <h2>What We Take </h2>
                <div className="line-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>Our comprehensive shed removal company removes:</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 md-6">
                <div className="price-card bbq-card bbq-card-sec cardb-card shed-card-sec">
                  <h4>Shed Structures:</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Wooden sheds</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>metal sheds</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>or plastic sheds of all sizes</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 md-6">
                <div className="price-card bbq-card">
                  <h4>Debris Removal:</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Shed debris</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>roofing</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>flooring</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>and construction debris</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 md-6">
                <div className="price-card bbq-card cardb-card appli-card">
                  <h4>Appliances:</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Hot tub removal</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>lawnmowers</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>and other large items</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 md-6">
                <div className="price-card bbq-card">
                  <h4>Miscellaneous Junk:</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Garden tools</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>furniture removal</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>and clutter left inside the shed</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 md-6">
                <div className="price-card bbq-card bulk-cards more-card-sec">
                  <h4>And More!</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>
                        We remove everything related to your shed removal
                        project.
                      </span>
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ===================== What We Take Section End Here ================ */}
        {/* ================== Before/After Section Start HERE =========================  */}
        <div className="container after-sec">
          <div className="row">
            <h2>
              <span>Before &amp; After</span> | Shed Removal
            </h2>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={64}
                height={4}
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                />
              </svg>
            </div>
            <div className="col-md-6 before-sec">
              <img
                src="/assets/img/Shed-removal-b-_-a.jpg"
                alt="Before-shed-removal-service"
                width="100%"
                loading="lazy"
              />
              <center>
                <button type="button" className="btn">
                  BEFORE
                </button>
              </center>
            </div>
            <div className="col-md-6 before-sec">
              <img
                src="/assets/img/Shed-removal-b-_-after.jpg"
                alt="After-shed-removal-services"
                width="100%"
                loading="lazy"
              />
              <center>
                <button type="button" className="btn">
                  After
                </button>
              </center>
            </div>
          </div>
        </div>
        {/* ================== FAQ's Section Start HERE =========================  */}
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2>
                  Shed Removal Services <span>FAQs</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              <ShedRemovalFAQs />
            </div>
          </div>
        </div>
        <UpperFooter />
      </>
    </div>
  );
}

export default Shed;
